// Libraries
import classNames from 'classnames';
import { ReactElement } from 'react';

// Assets
import { bestpricelogo, expiredlogo, expirylogo } from 'src/assets/QuoteStatus';

interface QuoteStatusPropTypes {
  statusType:
    | 'expired'
    | 'expiry'
    | 'bestprice'
    | 'bundled'
    | 'greige'
    | 'yarndyed'
    | 'jobwork'
    | 'denim'
    | string;
  statusValue?: string;
  className?: string;
}

interface QuoteStatusMapTypes {
  expired?: string;
  expiry?: string;
  bestprice?: string;
  bundled?: string;
  greige?: string;
  yarndyed?: string;
  jobwork?: string;
  denim?: string;
}

// Main Component
const QuoteStatus = ({
  statusType = '',
  statusValue = '--',
  className = '',
}: QuoteStatusPropTypes): ReactElement => {
  const QuoteStatusMsgMap: QuoteStatusMapTypes = {
    expired: 'Expired',
    expiry: `Expires in ${statusValue}`,
    bestprice: 'Best Price',
    bundled: 'Bundled',
    greige: 'Greige',
    yarndyed: 'Yarn dyed',
    jobwork: 'Job work',
    denim: 'Denim',
  };

  const QuoteStatuslogoMap: QuoteStatusMapTypes = {
    expired: expiredlogo,
    expiry: expirylogo,
    bestprice: bestpricelogo,
  };

  // Classes
  const quoteStatusClass = classNames({
    'border rounded-sm flex shadow-current': true,
    'border-statusRed w-fit pr-1 bg-statusBg': statusType === 'expiry',
    'border-statuslabel w-[66px] bg-label': statusType === 'expired',
    'border-statusOrange w-20 bg-statusOrange': statusType === 'bestprice',
    // 'border-statusBg h-5 w-14 bg-statusBg': statusType === 'greige',
    // 'bg-purpleBg border-purpleBg w-16 h-5': statusType === 'bundled',
    // 'border-statusBg h-5 w-[68px] bg-statusBg': statusType === 'yarndyed',
    // 'border-blueBg h-5 w-16 bg-blueBg': statusType === 'jobwork',
    // 'border-blueBg h-5 w-12 bg-blueBg': statusType === 'denim',
    'border-blueBg h-6 text-center pr-2 bg-blueBg': [
      'greige',
      'yarndyed',
      'bundled',
      'jobwork',
      'denim',
    ].includes(statusType),
  });

  const quoteStatusMsgClass = classNames({
    'text-xs font-normal text-center pt-0.5': true,
    'text-statusRed': statusType === 'expiry',
    'text-white': ['expired', 'bestprice'].includes(statusType),
    // 'text-textOrange': ['greige', 'yarndyed'].includes(statusType),
    // 'text-statusPurple': statusType === 'bundled',
    // 'text-textViolet': statusType === 'jobwork',
    // 'text-primeVioletThree': statusType === 'denim'
    'text-textViolet': ['greige', 'yarndyed', 'bundled', 'jobwork', 'denim'].includes(statusType),
  });

  return (
    <div className={`${className}`}>
      <div className={quoteStatusClass}>
        <img className="p-1" src={QuoteStatuslogoMap[statusType as keyof QuoteStatusMapTypes]} />
        <div className={quoteStatusMsgClass}>
          {QuoteStatusMsgMap[statusType as keyof QuoteStatusMapTypes]}
        </div>
      </div>
    </div>
  );
};

export default QuoteStatus;
